
/**
 * app debug 的支持方法
 * 
 * 支持在浏览器上使用调试对象为业务提供调试支持服务
 * 
 * 
 * 例如：
 * 	
 * 	浏览器提供对象
 *  window.debug = {		// 具体采用何种名字，由conf.appDebugNameSpace指定
 *  	debugProp1 : 'aaa'
 *  }
 *  
 *  业务端调用
 *  var debug = require("support/debug");
 * 	if (debug("debugProp1") == 'aaa') {
 * 		// debug code
 * 		
 * 	} else {
 * 		// normal code
 * 		
 * 	}
 * 
 * 
 */

var window = require("./window.js");
var conf = require("./conf.js");

module.exports = function(key, defaultValue) {
	// if debug object is undefined
	if (!window[conf.appDebugNameSpace]) {
		window[conf.appDebugNameSpace] = {};
	}
	// get debug properties
	var val = window[conf.appDebugNameSpace][key];
	if (val) {
		return val;
	} else {
		return defaultValue;
	}
}










//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/support/debug.js
// module id = 13
// module chunks = 0